import React, {useEffect, useState} from "react";
import useAgeType from "../Stores/AgeStore";

const MAX_SELECTED = 2;

interface AgeCompProps {
  onClose?: () => void;
}

const AgeComp: React.FC<AgeCompProps> = ({onClose}): JSX.Element => {
  const ageCompValue = useAgeType((s) => s.ageCompValue);
  const setAgeCompValue = useAgeType((s) => s.setAgeCompValue);
  const ageList = useAgeType((s) => s.ageList);

  const [tempSelection, setTempSelection] = useState<number[]>(ageCompValue);

  useEffect(() => {
    setTempSelection(ageCompValue);
  }, [ageCompValue]);

  const toggle = (idx: number) => {
    const next = tempSelection.includes(idx)
      ? tempSelection.filter((i) => i !== idx)
      : [...tempSelection, idx];

    setTempSelection(next);

    if (next.length === MAX_SELECTED) {
      setAgeCompValue(next);
      // Close menu when user makes a selection (changes from current state)
      if (
        JSON.stringify(next.sort()) !== JSON.stringify([...ageCompValue].sort())
      ) {
        onClose?.();
      }
    }
  };

  const isDisabled = (idx: number) =>
    !tempSelection.includes(idx) && tempSelection.length >= MAX_SELECTED;

  return (
    <div className="flex flex-col justify-center">
      <ul>
        {ageList.map((label: string, idx: number) => {
          const checked = tempSelection.includes(idx);
          const disabled = isDisabled(idx);
          return (
            <li key={idx}>
              <label className="label cursor-pointer justify-start ml-2 gap-0">
                <input
                  type="checkbox"
                  className="checkbox checkbox-xs checkbox-accent checked::border-accent bg-white"
                  checked={checked}
                  onChange={() => toggle(idx)}
                  disabled={disabled}
                />
                <div
                  className={`ml-2 ${
                    disabled ? "opacity-50" : "text-valmidnight"
                  }`}>
                  {label}
                </div>
              </label>
            </li>
          );
        })}
      </ul>
    </div>
  );
};

export default AgeComp;
